<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar v-if="this.side_function === 'true'" :dense="true">
        <v-toolbar-title class="body-2"> <v-icon>mdi-history</v-icon> Claim History </v-toolbar-title>
        <v-spacer />
        <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
      </v-toolbar>
      <v-data-table
        v-bind:headers="historyColumns"
        v-bind:items="historyItems"
        :server-items-length="totalHistoryItems"
        :footer-props="{ 'items-per-page-options': itemsPerPage }"
        v-bind:options.sync="paginationRIHeaders"
        item-key="key"
        :loading="loading"
        :no-data-text="noDataText"
      >
        <template v-slot:item="row"
          ><tr>
            <td>{{ row.item.entDate }}</td>
            <td>{{ row.item.clmStatDesc }}</td>
            <td>{{ row.item.clmtNo }}</td>
            <td>{{ row.item.clmItem }}</td>
            <td>{{ row.item.tranType1 }}</td>
            <td>{{ row.item.docNo }}</td>
            <td>{{ row.item.clmResCat }}</td>
            <td>{{ row.item.amtLoc }}</td>
            <td>{{ row.item.usrRefId }}</td>
          </tr></template
        >
      </v-data-table>
      <v-card-actions v-if="this.side_function === 'true'">
        <v-spacer />
        <v-btn color="red darken-1" text @click.native="doClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { claimHistoryMixin } from '@/mixins/claim/claimHistoryMixin'
import * as TableConst from '@/mixins/table'
export default {
  props: {
    side_function: {
      type: String,
      default: 'true'
    }
  },
  data() {
    return {
      loading: false,
      historyItems: [],
      totalHistoryItems: 0,
      paginationRIHeaders: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    reserves() {
      return this.commonInfo.clmReses
    }
  },
  methods: {
    doInit() {
      this.doFetchClaimHistory()
    },
    doClose() {
      this.$emit('close')
    },
    formatDisplayDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return ''
      }
    }
  },
  watch: {
    paginationRIHeaders: function (value) {
      this.doFetchClaimHistory()
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [MessageMixin, TableConst.default, claimHistoryMixin]
}
</script>

<style>
</style>
